import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import {
    APP_LANGUAGES,
    DEFAULT_LANGUAGE,
    DEFAULT_NAMESPACE,
    NAMESPACES,
    SUPPORTED_LANGUAGES,
    resolveInitialLanguage,
} from 'i18n/config'
import { resources } from 'i18n/resources'

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: resolveInitialLanguage(),
        fallbackLng: DEFAULT_LANGUAGE,
        supportedLngs: SUPPORTED_LANGUAGES,
        load: 'languageOnly',
        ns: NAMESPACES,
        defaultNS: DEFAULT_NAMESPACE,
        interpolation: { escapeValue: false }, // React ya escapa
        returnNull: false,
    })

// Plural rules of the regional variant (APP_LANGUAGES[].locale, e.g. pt → pt-PT: 0 is plural).
// i18next builds Intl.PluralRules from the bare code and caches it by that code; there is no public
// option for the region, so the cache entry is pre-seeded with the regional rules (i18next 23).
const pluralResolver = i18n.services?.pluralResolver
if (pluralResolver?.pluralRulesCache) {
    APP_LANGUAGES.filter(l => l.locale).forEach(({ value, locale }) => {
        pluralResolver.pluralRulesCache[JSON.stringify({ cleanedCode: value, type: 'cardinal' })] =
            new Intl.PluralRules(locale, { type: 'cardinal' })
    })
}

export default i18n
